<template>
  <div>
    <modal v-show="isModalVisible" @close="closeModal" footer>
      <template v-slot:title>
        <h5>Create Card Request</h5>
      </template>
      <template v-slot:body>
        <div>
          <div class="form-group">
            <label for="name">Account Number</label>
            <input type="text" class="form-control" :disabled="account_details != null" v-model="account_number"
              placeholder="Account Number" />
          </div>
        </div>
        <div v-if="step == 2">
          <div class="form-group">
            <label for="name">Name</label>
            <input type="text" class="form-control" v-model="account_details.name" placeholder="Name" disabled />
          </div>
          <!-- select delivery type -->
          <div class="form-group">
            <label for="name">Delivery Method</label>
            <select name="delivery_method" v-model="delivery_method" class="form-control">
              <option value="" selected>Please Select Delivery Method</option>
              <option value="pickup">Pickup</option>
              <option value="delivery">delivery</option>
            </select>
          </div>
          <div v-if="delivery_method == 'delivery'">
            <div class="form-group">
              <label for="name">Address</label>
              <input type="text" class="form-control" v-model="address" placeholder="Address" />
            </div>
            <div class="form-group">
              <label for="name">City</label>
              <input type="text" class="form-control" v-model="city" placeholder="City" />
            </div>
            <div class="form-group">
              <label for="state">State</label>
              <select name="state" v-model="state_id" class="form-control">
                <option value selected disabled>Select state</option>
                <option :value="state.id" v-for="state in states" :key="state.id">{{ state.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="name">Phone Number</label>
              <input type="text" class="form-control" v-model="phone_number" placeholder="Phone Number" />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button type="button" class="button" :disabled="formLoading" @click.prevent="formAction">
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">{{
              step === 1 ? "Checking Account..." : "Requesting Card..."
              }}</span>
          </span>
          <span v-else>
            {{ step === 1 ? "Check Customer" : "Request Card" }}
          </span>
        </button>
        <button class="btn btn-secondary" data-dismiss="modal" @click="closeModal">
          Cancel
        </button>
      </template>
    </modal>
    <modal v-show="isBatchModalVisible" @close="closeBatchModal" footer>
      <template v-slot:title>
        <h5>Export Batch</h5>
      </template>
      <template v-slot:body>
        <div>
          <div class="form-group">
            <label for="name">Date</label>
            <input type="date" class="form-control" v-model="batch_date"
              placeholder="Date" />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button type="button" class="button" :disabled="formLoading" @click.prevent="performAction">
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
          <span style="font-weight: 600; text-transform: initial;">
            Exporting Batch ...
          </span>
          </span>
          <span v-else>
            Export Batch
          </span>
        </button>
        <button class="btn btn-secondary" data-dismiss="modal" @click="closeBatchModal">
          Cancel
        </button>
      </template>
    </modal>
    <div v-if="loading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;">
      <div>
        <div>
          <h3>{{loading_message}}</h3>
        </div>
      </div>
    </div>
    <div class=" card card--no-shadow">
      <div class="card-header">

        <div class=" row justify-content-between">
          <div class="col-auto">
            <slot name="header">
              <h4>Card Requests</h4>
            </slot>
          </div>
          <div class="col-auto">
            <button 
            class="button" 
            @click="openModal"
            v-if="permissions.includes('request-card')"
            >
              Request Card
            </button>
            <button 
            class="button" 
            @click="openBatchModal"
            v-if="permissions.includes('request-batch-file')"
            >
              Export Batch
            </button>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="card-body">
          <div class="col-md-12">
            <div class="card card--no-shadow card-profile">
              <div class="card-header">
                <h3 class="font-weight-600 mb-0">Filter Loan Report</h3>
              </div>
              <div class="card-content">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="">Account Number</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="account_number_q"
                          placeholder="11111111111"
                          maxlength="11"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="">Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="name"
                          placeholder="11111111111"
                          maxlength="11"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <button
                        @click.prevent="getData(1)"
                        class="button mt-2"
                        :disabled="reportsLoading"
                      >
                        <span class="custom-loader" v-if="reportsLoading">
                          <loader-icon
                            size="1.5x"
                            class="custom-class"
                          ></loader-icon>
                          <span style="font-weight: 600; text-transform: initial;"
                            >Fetching Loan Data...</span
                          >
                        </span>
                        <span v-else>
                          Filter
                        </span>
                      </button>
                      <button
                        @click.prevent="clearFilter()"
                        class="button  mt-2"
                        :disabled="reportsLoading"
                      >
                        Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CDataTable :items="cards" :fields="fields" :itemsPerPage="cards.length" pagination sorter>
            <template #date="{ item }">
              <td class="table--action-mobile">
                {{ item.created_at | date }}
              </td>
            </template>
            <template #action="{ item }">
              <td class="table--action-mobile">
                <router-link class="button" :to="{
                  name: 'SingleCard',
                  params: { slug: item.request_reference }
                }">View Request</router-link>
              </td>
            </template>
            <template #name="{ item }">
              <td class="table--action-mobile">
                <div v-if="item.user">{{ item.user.first_name }} {{ item.user.last_name}}</div>
                <div v-else>
                  <i style="color: red;">CBA User</i>
                </div>
                 <span class="badge" 
                    :class="{
                      'badge-success': item.card_category == 'kiddies',
                      'badge-default':  item.card_category == 'normal'
                    }"
                    >                        
                      {{ item.card_category | capitalize }} Card
                  </span>
              </td>
            </template>
          </CDataTable>
          <CPagination :activePage.sync="next_page" :pages="total" :onActivePageChange="onPageChange()"></CPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "../../components/CDataTable.vue";
import CPagination from "../../components/CPagination.vue";
import ApiService from "../../services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";

const fields = [
  "name",
  "account_number",
  "request_reference",
  "delivery_method",
  "provision_status",
  "delivery_status",
  "payment_status",
  "request_status",
  "date",
  "action"
];
export default {
  name: "CardsVue",
  components: {
    CDataTable,
    CPagination
  },
  data() {
    return {
      loading_message: "Getting Card Request ready...",
      fields,
      account_number_q: "",
      name: "",
      isModalVisible: false,
      isBatchModalVisible: false,
      formLoading: false,
      loading: true,
      account_details: null,
      account_number: "",
      cards: [],
      states: [],
      step: 1,
      next_page: 1,
      total: 1,
      current: 1,
      delivery_method: "",
      address: "",
      city: "",
      phone_number: "",
      state_id: "",
      batch_date: "",
      reportsLoading: false

    };
  },
  methods: {
    clearFilter() {
      this.account_number_q = "";
      this.name = "";
      this.getData(1);
    },
    openModal() {
      this.isModalVisible = true;
      this.step = 1;
      this.account_number = "";
    },
    openBatchModal() {
      this.isBatchModalVisible = true;
      this.step = 1;
      this.account_number = "";
    },
    async getData(page) {
      this.closeModal;
      this.loading_message = "Getting Card Request ready...";
      this.loading = true;      
      try {
        const res = await ApiService.get(`card/all-card-request?page=${page}&account_number=${this.account_number_q}&name=${this.name}`);
        this.cards = res.data.data.data;
        this.current = res.data.data.current_page;
        this.total = res.data.data.last_page;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error.response);
      }
    },
    async formAction() {
      if (this.step === 1) {
        this.getAccountDetails();
      } else {
        this.requestCard();
      }
    },
    async getStates() {
      try {
        const response = await ApiService.get("utility/state-list");
        this.states = response.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getAccountDetails() {
      try {
        this.formLoading = true;
        const response = await ApiService.post("account/check_account_details", {
          account_number: this.account_number
        });
        this.account_details = response.data.data;
        this.formLoading = false;
        this.step = 2;
      } catch (error) {
        this.formLoading = false;
        console.log(error.response);
        ErrorService.displayErrorAlert(_error);
      }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        console.log(this.next_page);
        this.getData(this.next_page);
      }
    },
    closeModal() {
      this.isModalVisible = false;
      this.account_details = null;
      this.step = 1;
    },
    closeBatchModal() {
      this.isBatchModalVisible = false;
      this.batch_date = "";
    },
    async requestCard() {
      this.isModalVisible = false;
      Swal.fire({
        title: `Are you sure you want to request this card for ${this.account_details.name}?`,
        showCancelButton: true,
        confirmButtonText: `Yes, Request The Card`,
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.formLoading = true;
            this.loading_message = "Requesting Card...";
            this.loading = true;
            const response = await ApiService.post("card/create-card-request", {
              account_number: this.account_number,
              delivery_method: this.delivery_method,
              address: this.address,
              city: this.city,
              state_id: this.state_id,
              phone_number: this.phone_number,
              source: 'admin'
            });
            console.log(response);
            this.formLoading = false;
            this.loading = false;
            Swal.fire({
              title: "Success",
              text: response.data.message,
              icon: "success",
              timer: 3000,
              confirmButtonText: "Close",
              showConfirmButton: false
            });
            this.getData(1);            
          } catch (error) {
            this.formLoading = false;
            this.loading = false;
            console.log(error.response);
            ErrorService.displayErrorAlert(error);
          }
        }
      });
    },
    async performAction() {
        this.formLoading = true;
        try {
            let response = await ApiService.post("card/request-batch-file", {
                batch_date: this.batch_date,
            });
            var url = response.data.data.download_url
            // open in  new tab
            window.open(url, '_blank');
            this.formLoading = false;
        } catch (error) {
            console.log(error.response);
            this.formLoading = false;
            ErrorService.displayErrorAlert(error.response.data);
        }
    },
  },
  mounted() {
    this.getData(1);
    this.getStates();
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
  }
};
</script>

<style scoped></style>
